export const leadershipCornerPageUrl = '/leadership-corner';
export const leadershipCornerFeaturedConversationsUrl = '/leadership-corner/featured-conversations';
export const leaderDashboardPageUrl = '/leadership-corner/leader-dashboard';
